import styled from '@emotion/styled';

const Section = styled.section`
	padding: 1.5rem;
	background: #404040;
	color: white;
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 1rem;
`;

const Logo = styled.img`
	max-height: 2.5rem;
	object-fit: contain;
`;

export default function PoweredBlockEpsilon({ tenantLogo }: { tenantLogo: string }) {
	return (
		<Section>
			<span>Presented By</span>
			<Logo src={tenantLogo} alt="Tenant logo" />
		</Section>
	);
}
